function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 5.01636C0 2.25493 2.23858 0.0163574 5 0.0163574H43C45.7614 0.0163574 48 2.25493 48 5.01636V15.0164H33V0.0170898H31V24.0164L0 24.0164V5.01636Z",
  fill: "#18A43B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 26.0164L31 26.0164V48.0164H5C2.23858 48.0164 0 45.7778 0 43.0164V26.0164Z",
  fill: "#18A43B"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M33 34.0164V48.0164H43C45.7614 48.0164 48 45.7778 48 43.0164V34.0164H33Z",
  fill: "#18A43B"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M33 32.0164H48V17.0164H33V32.0164Z",
  fill: "#18A43B"
});

var Svg5BActive = function Svg5BActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg5BActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/5b_active.e7ad772c.svg";
export { ForwardRef as ReactComponent };